export const IS_SENTRY_ENABLED = import.meta.env.VITE_SENTRY_ENABLED === 'true';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_REPLAY_SAMPLE_RATE = import.meta.env.VITE_SENTRY_REPLAY_SAMPLE_RATE;
export const SENTRY_TRACE_SAMPLE_RATE = import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE;
